import { format } from 'date-fns';

import { type FilterDimension } from '../../../../../components/FilterSheet';

export interface JobNoteFilterValues {
  departmentId: number;
  startDate: Date | undefined;
  endDate: Date | undefined;
  startTime: string | undefined;
  endTime: string | undefined;
  createdByIds: number[];
  searchText: string;
  eventId: number;
}

export const defaultJobNoteFilterValues: JobNoteFilterValues = {
  departmentId: 0,
  startDate: undefined,
  endDate: undefined,
  startTime: undefined,
  endTime: undefined,
  createdByIds: [],
  searchText: '',
  eventId: 0,
};

const formatDay = (date: Date | undefined) => (date ? format(date, 'M/d/yyyy') : '');

/** A job's or project's note filters, as the filter sheet and its chips show them. */
export const jobNoteFilterDimensions: FilterDimension<JobNoteFilterValues>[] = [
  { id: 'department', label: 'Department', fields: ['departmentId'] },
  {
    id: 'createdBy',
    label: 'Created By',
    fields: ['createdByIds'],
    summary: (values) => `${values.createdByIds.length} selected`,
  },
  { id: 'job', label: 'Job', fields: ['eventId'], summary: (values) => `#${values.eventId}` },
  {
    id: 'dates',
    label: 'Dates',
    fields: ['startDate', 'endDate', 'startTime', 'endTime'],
    summary: (values) =>
      [formatDay(values.startDate), formatDay(values.endDate)].filter(Boolean).join(' to ') || null,
  },
];
